"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerPricingQuery = exports.HaulerPublicPricingQuery = exports.HaulerPricingZoneUpdate = exports.HaulerPricingZoneCreate = exports.HaulerPricingZone = exports.HaulerPricingZoneNested = exports.HaulerServiceAreaMutate = exports.HaulerServiceAreaTransport = exports.PricingMaterialMutate = exports.HaulerPricingZoneType = exports.PricingMaterial = exports.HaulerPricingDataMutate = exports.HaulerPricingDataTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const ca_state_1 = require("./ca-state");
const customer_discount_transport_1 = require("./customer-discount-transport");
const fee_1 = require("./fee");
const pricing_data_transport_1 = require("./pricing-data-transport");
const pricing_transport_1 = require("./pricing-transport");
const service_area_envelope_1 = require("./service-area-envelope");
const us_state_1 = require("./us-state");
exports.HaulerPricingDataTransport = typebox_1.Type.Omit(pricing_data_transport_1.MaterialPricingTransport, ['allowOnlineCheckout']);
// Included so that if HaulerPricingDataMutate diverges from HaulerPricingDataTransport, dependents don't need to change the type name.
exports.HaulerPricingDataMutate = exports.HaulerPricingDataTransport;
exports.PricingMaterial = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    details: typebox_1.Type.Intersect([
        exports.HaulerPricingDataTransport,
        typebox_1.Type.Object({
            customerDiscountApplied: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
            discountCustomerID: typebox_1.Type.Optional(typebox_1.Type.String()),
        }),
    ]),
    effectiveDate: typebox_1.Type.String(),
    expirationDate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
});
exports.HaulerPricingZoneType = typebox_1.Type.Union([typebox_1.Type.Literal('SOURGUM'), typebox_1.Type.Literal('GENERAL')]);
exports.PricingMaterialMutate = typebox_1.Type.Omit(exports.PricingMaterial, ['id']);
exports.HaulerServiceAreaTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    serviceArea: service_area_envelope_1.ServiceAreaEnvelope,
    areaName: typebox_1.Type.Optional(typebox_1.Type.String()),
    taxJurisdiction: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.HaulerServiceAreaMutate = typebox_1.Type.Object({
    serviceArea: typebox_1.Type.String(),
    serviceAreaFormat: typebox_1.Type.Union([typebox_1.Type.Literal('KML'), typebox_1.Type.Literal('GEOJSON')]),
    areaName: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    taxJurisdiction: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
});
exports.HaulerPricingZoneNested = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    serviceAreas: typebox_1.Type.Array(exports.HaulerServiceAreaTransport),
    haulerID: typebox_1.Type.String(),
    haulerName: typebox_1.Type.String(),
    materials: typebox_1.Type.Array(exports.PricingMaterial),
    fees: typebox_1.Type.Array(fee_1.PricingFee),
    prohibitedItems: typebox_1.Type.Array(typebox_1.Type.String()),
    state: typebox_1.Type.Union([us_state_1.UsStateAbbreviation, ca_state_1.CAProvinceAbbreviation]),
    tripCharge: typebox_1.Type.Integer(),
    days: typebox_1.Type.Object({
        mon: pricing_transport_1.PricingDataDailyAvailibity,
        tue: pricing_transport_1.PricingDataDailyAvailibity,
        wed: pricing_transport_1.PricingDataDailyAvailibity,
        thu: pricing_transport_1.PricingDataDailyAvailibity,
        fri: pricing_transport_1.PricingDataDailyAvailibity,
        sat: pricing_transport_1.PricingDataDailyAvailibity,
        sun: pricing_transport_1.PricingDataDailyAvailibity,
    }),
    customerDiscounts: typebox_1.Type.Optional(typebox_1.Type.Array(customer_discount_transport_1.EmbeddedCustomerDiscountTransport)),
    rentalPeriod: typebox_1.Type.Optional((0, common_1.Nullable)(common_1.Duration)),
    rentExtensionFee: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Integer())),
    zoneName: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    pricingCalculationVersion: typebox_1.Type.Optional(typebox_1.Type.String()),
    maxRentalDaysAllowed: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    prePaidRentalDaysDiscountRate: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    allowForPrePaidRentalDays: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    haulerApproved: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    sourgumApproved: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    onlineCheckoutTiers: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Any())),
    type: exports.HaulerPricingZoneType,
    actualTaxRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    taxRateOverride: typebox_1.Type.Optional(typebox_1.Type.Number()),
    metadata: typebox_1.Type.Optional(typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    })),
});
exports.HaulerPricingZone = typebox_1.Type.Intersect([
    exports.HaulerPricingZoneNested,
    typebox_1.Type.Object({
        linkedZone: typebox_1.Type.Optional(exports.HaulerPricingZoneNested),
    }),
]);
exports.HaulerPricingZoneCreate = typebox_1.Type.Omit(exports.HaulerPricingZoneNested, [
    'id',
    'fees',
    'haulerID',
    'materials',
    'serviceAreas',
    'metadata',
    'sourgumApproved',
    'actualTaxRate',
]);
exports.HaulerPricingZoneUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.HaulerPricingZoneCreate, ['taxRateOverride']),
    typebox_1.Type.Object({
        taxRateOverride: (0, common_1.Nullable)(typebox_1.Type.Number()),
    }),
]));
exports.HaulerPublicPricingQuery = typebox_1.Type.Object({
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    zip: typebox_1.Type.String(),
    country: typebox_1.Type.String(),
    lat: typebox_1.Type.Number(),
    lng: typebox_1.Type.Number(),
});
exports.HaulerPricingQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    includeExpiredMaterials: typebox_1.Type.Boolean(),
    includeExpiredFees: typebox_1.Type.Boolean(),
    limit: typebox_1.Type.Integer(),
    offset: typebox_1.Type.Integer(),
    lat: typebox_1.Type.Number(),
    lng: typebox_1.Type.Number(),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    type: typebox_1.Type.Union([typebox_1.Type.Literal('SOURGUM'), typebox_1.Type.Literal('GENERAL')]),
}));
//# sourceMappingURL=hauler.js.map